<template>
  <v-container class="payments-container">
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-text-field
            v-model="selectedMonth"
            type="month"
            :max="maxMonth"
            label="Период"
            density="compact"
            variant="outlined"
            hide-details
            class="mx-4 mt-3"
            style="max-width: 220px"
            @change="fetchPayments"
          />
          
          <v-table density="compact">
            <thead>
              <tr>
                <th>Терминал</th>
                <th>Сумма</th>
                <th>Дата</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in userdata" :key="item.id">
                <td>{{ item.place }}</td>
                <td>{{ (item.amount / 100).toFixed(2) }} €</td>
                <td class="text-no-wrap">{{ formatDate(item.datetime) }}</td>
              </tr>
            </tbody>
          </v-table>
          <v-card-text v-if="userdata.length === 0" class="text-center text-medium-emphasis">
            Нет платежей за выбранный период
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

interface Payment {
  id: number
  place: string
  amount: number
  datetime: string
}

const userStore = useUserStore()
const userdata = ref<Payment[]>([])

const now = new Date()
const pad = (n: number) => String(n).padStart(2, '0')
const selectedMonth = ref(`${now.getFullYear()}-${pad(now.getMonth() + 1)}`)
const maxMonth = `${now.getFullYear()}-${pad(now.getMonth() + 1)}`

const formatDate = (datetime: string) => {
  if (!datetime) return ''
  const d = new Date(datetime)
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

const getPhoneNumber = () => {
  return userStore.state.context.user?.phoneNumber?.substring(4) || ''
}

const fetchPayments = async () => {
  if (userStore.state.value === 'authenticated') {
    const phoneNumber = getPhoneNumber()
    if (!phoneNumber) return

    try {
      const response = await axios.get(
        `${API_BASE_URL}/getuserinfo2paymants?number=${phoneNumber}&month=${selectedMonth.value}`
      )
      userdata.value = response.data
    } catch (error) {
      console.error('Error fetching payments:', error)
    }
  }
}

watch(
  () => userStore.state.value,
  async (state) => {
    if (state === 'authenticated') {
      await fetchPayments()
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.payments-container {
  padding-bottom: 56px !important;
  margin-bottom: 56px !important;
}

:deep(.v-card) {
  padding: 16px;
}

:deep(.v-table) {
  background: transparent;
}
</style>